import './index.css';
import './i18n';
import './core/styles/resetStyles.module.css';

import './helpers/socket';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
import configureStore from './store/configureStore';
import FontCreatorPageContainer from './pages/fontCreatorPage/FontCreatorPageContainer';
import {
  basePageUrl, editorPageUrl, faqPageUrl, fontCreatorPageUrl, offerPageUrl, oldBasePageUrl, newBasePageUrl, policyPageUrl, profilePageUrl, resetPasswordPageUrl, pricingPageUrl, privacyPageUrl, refundPageUrl, termsPageUrl, aiPageUrl, paymentPageUrl, flashcardsPageUrl, flashcardsTopicPageUrl, recognizePageUrl, photoToTextPageUrl, audioToTextPageUrl, youtubeToTextPageUrl, pdfToTextPageUrl
} from './helpers/urls';
import LandingPageContainer from './pages/landingPage/LandingPageContainer';
import { AsyncMainPageContainer } from './pages/mainPage/AsyncMainPageContainer';
import { AsyncOldMainPageContainer } from './pages/oldMainPage/AsyncOldMainPageContainer';
import { LoaderComponent } from './core/components/loader/LoaderComponent';
import { AsyncOfferPageContainer } from './pages/offerPage/AsyncOfferPageContainer';
import { AsyncPolicyPageContainer } from './pages/policyPage/AsyncPolicyPageContainer';
import './analytics';
import { AsyncFaqPageContainer } from './pages/faqPage/AsyncFaqPageContainer';
import ProfilePageContainer from './pages/profilePage/ProfilePageContainer';
import AsyncResetPasswordPageContainer from './pages/resetPasswordPage/AsyncResetPasswordPageContainer';
import { AsyncPricingPageContainer } from './pages/pricingPage/AsyncPricingPageContainer';
import { AsyncPrivacyPageContainer } from './pages/privacyPage/AsyncPrivacyPageContainer';
import { AsyncRefundPageContainer } from './pages/refundPage/AsyncRefundPageContainer';
import { AsyncTermsPageContainer } from './pages/termsPage/AsyncTermsPageContainer';
import { AsyncAiPageContainer } from './pages/aiPage/AsyncAiPageContainer';
import { AsyncPaymentPageContainer } from './pages/paymentPage/AsyncPaymentPageContainer';
import { AsyncFlashcardsPageContainer } from './pages/flashcardsPage/AsyncFlashcardsPageContainer';
import { RecognizePageContainer } from './pages/recognizePage/RecognizePageContainer';
import { PhotoToTextPageContainer } from './pages/photoToTextPage/PhotoToTextPageContainer';
import { AudioToTextPageContainer } from './pages/audioToTextPage/AudioToTextPageContainer';
import { YoutubeToTextPageContainer } from './pages/youtubeToTextPage/YoutubeToTextPageContainer';
import { PdfToTextPageContainer } from './pages/pdfToTextPage/PdfToTextPageContainer';

const store = configureStore();

ReactDOM.render(
    <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
          <Suspense fallback={<LoaderComponent />}>
              <Routes>
                  <Route path={basePageUrl} element={<LandingPageContainer />} />
                  <Route path={editorPageUrl} element={<AsyncMainPageContainer />} />
                  <Route path={oldBasePageUrl} element={<AsyncOldMainPageContainer />} />
                  <Route path={fontCreatorPageUrl} element={<FontCreatorPageContainer />} />
                  <Route path={profilePageUrl} element={<ProfilePageContainer />} />
                  <Route path={resetPasswordPageUrl} element={<AsyncResetPasswordPageContainer />} />
                  <Route path={offerPageUrl} element={<AsyncOfferPageContainer />} />
                  <Route path={faqPageUrl} element={<AsyncFaqPageContainer />} />
                  <Route path={pricingPageUrl} element={<AsyncPricingPageContainer />} />
                  {/* <Route path={policyPageUrl} element={<AsyncPolicyPageContainer />} /> */}
                  <Route path={privacyPageUrl} element={<AsyncPrivacyPageContainer />} />
                  <Route path={refundPageUrl} element={<AsyncRefundPageContainer />} />
                  <Route path={termsPageUrl} element={<AsyncTermsPageContainer />} />
                  <Route path={aiPageUrl} element={<AsyncAiPageContainer />} />
                  <Route path={`${aiPageUrl}:chatId`} element={<AsyncAiPageContainer />} />
                  <Route path={paymentPageUrl} element={<AsyncPaymentPageContainer />} />
                  <Route path={flashcardsPageUrl} element={<AsyncFlashcardsPageContainer />} />
                  <Route path={flashcardsTopicPageUrl} element={<AsyncFlashcardsPageContainer />} />
                  <Route path={recognizePageUrl} element={<RecognizePageContainer />} />
                  <Route path={photoToTextPageUrl} element={<PhotoToTextPageContainer />} />
                  <Route path={audioToTextPageUrl} element={<AudioToTextPageContainer />} />
                  <Route path={youtubeToTextPageUrl} element={<YoutubeToTextPageContainer />} />
                  <Route path={pdfToTextPageUrl} element={<PdfToTextPageContainer />} />
              </Routes>
          </Suspense>
      </Provider>
    </BrowserRouter>
    </HelmetProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
